import type { RecordState } from "@cyh/contracts";
import { useLanguage } from "../i18n";

export function RecordArchiveFilter({ value, onChange }: { value: RecordState; onChange: (state: RecordState) => void }) {
  const { t } = useLanguage();
  return <label className="record-archive-filter">{t("记录状态", "Record state")} <select aria-label={t("记录状态筛选", "Filter record state")} value={value} onChange={event=>onChange(event.target.value as RecordState)}>
    <option value="ACTIVE">{t("正常记录", "Active")}</option>
    <option value="DELETED">{t("已删除", "Deleted")}</option>
    <option value="ALL">{t("全部记录", "All records")}</option>
  </select></label>;
}

export function RecordDeletedBadge({ deletedAt }: { deletedAt?: string | null }) {
  const { t } = useLanguage();
  return deletedAt ? <small className="record-deleted-badge" title={new Date(deletedAt).toLocaleString()}>{t("已删除 · 仅可查看", "Deleted · read only")}</small> : null;
}
